import React from 'react';
import { Navigate } from 'react-router-dom';
import { AddTask } from '@components/ToDo/AddTask';
import { DefaultLayout } from '../layouts';

import Dashboard from '../pages/Dashboard/Dashboard';
import Referrals from '../pages/Referrals/Referrals';
import Setup from '../pages/Setup/Setup';
import InviteReferrer from '../pages/InviteReferrer/InviteReferrer';
import Account from '../pages/Acount/Account';
import Help from '../pages/Help/Help';
import ReferReferUs from '../pages/ReferReferUs/ReferReferUs';
import SocialMedia from '../pages/SocialMedia/SocialMedia';
import ReferUsNetwork from '../pages/ReferUsNetwork/ReferUsNetwork';
import ComapanyIRefer from '../pages/ComapanyIRefer/ComapanyIRefer';
import MyReferrer from '../pages/MyReferrer/MyReferrer';
import ReferralAdd from '../pages/Referrals/ReferralAdd';
import UploadCsvReferrer from '../pages/CSVUpload/UploadCsvReferrer';
import InviteBusiness from '../pages/ComapanyIRefer/InviteBusiness';

export const BusinessAdminRoutes = [
    {
        path: '/',
        exact: true,
        layout: DefaultLayout,
        component: () => <Navigate to="/dashboard" />,
    },
    {
        path: '/dashboard',
        exact: true,
        layout: DefaultLayout,
        component: Dashboard,
    },
    {
        path: '/setup',
        exact: true,
        layout: DefaultLayout,
        component: Setup,
    },
    {
        path: '/my-referrals',
        exact: true,
        layout: DefaultLayout,
        component: Referrals,
    },
    {
        path: '/my-referrers',
        exact: true,
        layout: DefaultLayout,
        component: MyReferrer,
    },
    {
        path: '/refer-referus',
        exact: true,
        layout: DefaultLayout,
        component: ReferReferUs,
    },
    {
        path: '/business-i-refer',
        exact: true,
        layout: DefaultLayout,
        component: ComapanyIRefer,

    },
    {
        path: '/my-network',
        exact: true,
        layout: DefaultLayout,
        component: ComapanyIRefer,

    },
    {
        path: '/invite-a-referrer',
        exact: true,
        layout: DefaultLayout,
        component: InviteReferrer,
    },
    {
        path: '/invite-a-business',
        exact: true,
        layout: DefaultLayout,
        component: InviteBusiness,
    },
    {
        path: '/social-media',
        exact: true,
        layout: DefaultLayout,
        component: SocialMedia,
    },
    {
        path: '/referus-network',
        exact: true,
        layout: DefaultLayout,
        component: ReferUsNetwork,
    },
    {
        path: '/send-referral',
        exact: true,
        layout: DefaultLayout,
        component: ReferralAdd,
    },
    {
        path: '/view-referral',
        exact: true,
        layout: DefaultLayout,
        component: ReferralAdd,
    },
    {
        path: '/view-referrer',
        exact: true,
        layout: DefaultLayout,
        component: InviteReferrer,
    },
    {
        path: '/upload-referrer',
        exact: true,
        layout: DefaultLayout,
        component: UploadCsvReferrer,
    },
    {
        path: '/account',
        exact: true,
        layout: DefaultLayout,
        component: Account,
    },
    {
        path: '/help',
        exact: true,
        layout: DefaultLayout,
        component: Help,
    },
];
